export default __webpack_public_path__ + "static/media/selecta_main_mobile@2x.2b302833.jpg";